import { t } from "i18next";
import type { JSX } from "react";
import type { TranscriptionProviderOption } from "@/common/types/types";
import { Label } from "@/components/ui/label";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@/components/ui/Toggle/toggle-group";
import { TooltipHelp } from "@/components/ui/TooltipHelp";

interface Props {
  value: string;
  onChange: (value: string) => void;
  values: TranscriptionProviderOption[];
}

export const TranscriptionProvidersSelector = (props: Props): JSX.Element => {
  return (
    <div className="flex items-center gap-4">
      <div className="w-full">
        <Label className="text-tinted-grey-3 text-sm">
          {t("components.advancedSettings.transcriptionProvider.label")}
        </Label>
        <div className="flex items-center gap-4">
          <ToggleGroup
            className="w-full"
            type="single"
            value={props.value}
            onValueChange={props.onChange}
          >
            {props.values.map((provider) => (
              <ToggleGroupItem
                key={provider.value}
                className="flex-1"
                value={provider.value}
              >
                {provider.label}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
          <TooltipHelp
            content={t(
              "components.advancedSettings.transcriptionProvider.tooltip",
            )}
          />
        </div>
      </div>
    </div>
  );
};
